import { get, patch, post } from '../../utils/http';

export const fetchPayrollFields = ({ accountId }) => get(`/accounts/${accountId}/payroll/fields`);

export const addPayrollField = ({ accountId, field }) => post(`/accounts/${accountId}/payroll/fields`, field);

export const updatePayrollField = ({ accountId, fieldId, field }) =>
  patch(`/accounts/${accountId}/payroll/fields/${fieldId}`, field);

export const deletePayrollField = ({ accountId, fieldId, deleteFromPast = false }) =>
  patch(`/accounts/${accountId}/payroll/fields/${fieldId}`, { isDeleted: true, deleteFromPast });
